'use client';

import { create } from 'zustand';

type GalleryState = {
    isModalOpen: boolean;
    initialModalIndex: number;
    openModal: (initialIndex: number) => void;
    closeModal: () => void;
};

export const useGalleryStore = create<GalleryState>(set => ({
    isModalOpen: false,
    initialModalIndex: 0,
    openModal: (initialIndex: number) => set({ isModalOpen: true, initialModalIndex: initialIndex }),
    closeModal: () => set({ isModalOpen: false }),
}));
